var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.473,
    height: 19.608,
    viewBox: "0 0 19.473 19.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tag",
    "data-name": "Icon awesome-tag",
    d: "M0,9.1V1.732A1.732,1.732,0,0,1,1.732,0H9.1a1.732,1.732,0,0,1,1.225.507l7.645,7.645a1.732,1.732,0,0,1,0,2.449L10.6,17.965a1.732,1.732,0,0,1-2.449,0L.507,10.321A1.732,1.732,0,0,1,0,9.1ZM4.041,2.309A1.732,1.732,0,1,0,5.773,4.041,1.732,1.732,0,0,0,4.041,2.309Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ef7bf93d13321275b5751d5170692c1d.svg";
export { ForwardRef as ReactComponent };